import React from 'react';

import {
  LoadingTaskFileIcon,
  RemoveTaskFileIcon,
  TaskFileContent,
  TaskFileName,
  TaskFilePickerChip,
  TaskFileType,
} from './styles';

import { LoadingIcon } from 'components/LoadingIcon/LoadingIcon';
import { IRelatedProviderItem } from 'store/providers/providerTypes';
import LocalIcon from 'ui/LocalIcon';
import { summerizeText } from 'utils/summerizeText';
import HoverIcon from 'components/HoverIcon';
import {
  blue,
  green,
  orange,
  purple,
  red,
} from '../../../../../utils/style/colors';

interface IComponentProps {
  isLoading?: boolean;
  item: IRelatedProviderItem;
  onRemove?: (item: IRelatedProviderItem) => (e: any) => void;
  onOpen: (
    item: IRelatedProviderItem
  ) => (e: React.MouseEvent<HTMLSpanElement, MouseEvent>) => void;
}

const TaskFileChip: React.FC<IComponentProps> = ({
  isLoading,
  item,
  onOpen,
  onRemove,
}) => {
  return (
    // <span style={{ backgroundColor: exactWhite, borderRadius: '2rem' }}>
    <TaskFilePickerChip onClick={onOpen(item)}>
      <TaskFileName>
        <TaskFileType
          type={item.type}
          color={
            item.type === 'document'
              ? blue
              : item.type === 'folder'
                ? orange
                : item.type === 'surveyReport'
                  ? green
                  : item.type === 'survey'
                    ? purple
                    : red
          }
        >
          <LocalIcon
            iconName={
              item.type === 'document'
                ? 'text.svg'
                : item.type === 'quill'
                  ? 'document.svg'
                  : item.type === 'folder'
                    ? 'zip.svg'
                    : item.type === 'survey'
                      ? 'survey.svg'
                      : 'link.svg'
            }
          />
        </TaskFileType>
        <TaskFileContent editable={onRemove}>
          {summerizeText(item.title, 55)}
        </TaskFileContent>
        {isLoading ? (
          <LoadingTaskFileIcon>
            <LoadingIcon color="gray" />
          </LoadingTaskFileIcon>
        ) : onRemove ? (
          <RemoveTaskFileIcon>
            <HoverIcon color="red" type="trash" onClick={onRemove!(item)} />
          </RemoveTaskFileIcon>
        ) : undefined}
      </TaskFileName>
    </TaskFilePickerChip>
    // </span>
  );
};

export default TaskFileChip;
